/* eslint-disable jsx-a11y/img-redundant-alt */
import React from 'react'
import { IBrokenImage } from './types'
import { functions } from '@wap-client/core'

const BrokenImage: React.FC<IBrokenImage> = ({ className = '' }) => {
  return (
    <div className={functions.classnames('c-broken-image')}>
      <img
        src={
          className?.includes('thumbnail')
            ? '/images/broken-image-600_600.webp'
            : '/images/broken-image-1880_1040.webp'
        }
        alt="GoTurkiye broken image"
      />
    </div>
  )
}

export default BrokenImage
